import type { Field } from 'garaje/models/location';
import type LocalStorageService from 'garaje/services/local-storage';

export type ColumnPreferencesMap = Record<string, Field[]>;

function getCompositeKey(userId: string, locationId: string): string {
  return `${userId}-${locationId}`;
}

export function loadColumnPreferences(
  localStorage: LocalStorageService,
  storageKey: string,
  userId: string | undefined,
  locationId: string,
  defaultFields: Field[],
): Field[] {
  if (!userId) {
    return [...defaultFields];
  }

  try {
    const storedData = localStorage.getItem(storageKey);
    if (storedData) {
      const preferences = JSON.parse(storedData) as ColumnPreferencesMap;
      const compositeKey = getCompositeKey(userId, locationId);
      if (preferences[compositeKey]) {
        return [...preferences[compositeKey]];
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return [...defaultFields];
}

export function saveColumnPreferences(
  localStorage: LocalStorageService,
  storageKey: string,
  userId: string | undefined,
  locationId: string,
  fields: Field[],
): boolean {
  if (!userId || !locationId) {
    return false;
  }

  try {
    const storedData = localStorage.getItem(storageKey);
    const preferences: ColumnPreferencesMap = storedData ? (JSON.parse(storedData) as ColumnPreferencesMap) : {};

    const compositeKey = getCompositeKey(userId, locationId);
    preferences[compositeKey] = fields;

    localStorage.setItem(storageKey, JSON.stringify(preferences));
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return false;
  }
}
